import React, { useState, useEffect, useMemo, useContext, useRef } from 'react';
import _ from 'underscore';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import services from '../../../services/services.js';
import { Urls } from '../../../services/Urls.js'
import { callautopopulate } from '../../../services/callautopop.js';
import { ToastContext } from '../../../context/ToastContext.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const useControlcentre = () => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    let obj;
    let payload
    const [gridData, setgridData] = useState([]);
    const [assignPermission, setAssignPermission] = useState([]);
    const [checkedStates, setCheckedStates] = useState({});
    const [check, setCheck] = useState({});
    const [permission, setPermission] = useState({})
    const [userpermission, setuserPermission] = useState([])
    const [User, setUser] = useState([]);
    const [filterValues, setFilterValues] = useState({});
    const [usercategory, setusercategory] = useState([]);
    const [currentUserAccountId, setcurrentUserAccountId] = useState('')
    const tagRef = useRef(null);
    const [loader, setLoader] = useState(true)
    const [categoryPopup, setCategoryPopup] = useState(false);
    const [popupData, setPopupData] = useState({});
    const [popupDataSelected, setPopupDataSelected] = useState({ users: [], categories: [] });
    const [globalFilter, setGlobalFilter] = useState("");
    const [expandedKeys, setExpandedKeys] = useState({});
    const [treeData, setTreeData] = useState([])



    useEffect(() => {
        callautopopulate("user_info", "users", "user_category").then(res => {
            setUser(_.sortBy(res?.users, "user_display_name"));
            setusercategory(_.sortBy(res?.user_category, "user_category_name"));
            getMyPermissons(res?.user_info);
        });
    }, []);

    const headerTemplate = (data) => {
        return (
            <React.Fragment>
                <span className="vertical-align-middle ml-2 font-bold line-height-3">{data.parent_resource_name}</span>
            </React.Fragment>
        );
    };

    const getMyPermissons = async (user_info) => {
        setLoader(true)
        try {
            const payload = {
                "user_category_id": user_info[0]?.user_category_id
            };

            const res = await services.getInvokeRemote('POST', Urls('GETRESOURCEPERMISSION'), payload)
            if (!_.isEmpty(res)) {
                if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 || res.body.StatusCode === 500) {
                    showError('Error', res.body.errorMessage);
                }
                else if (res?.body?.data?.resourcePermission) {
                    const result = _.uniq(res.body.data.resourcePermission, "resource_key");
                    const isActive = _.where(result, { is_active: true });
                    const isEdit = _.where(result, { is_editable: true })
                    if (!_.isEmpty(isActive)) {
                        isActive.map(active => {
                            const getData = "display_" + active.resource_key
                            setCheckedStates((prevState) => ({
                                ...prevState,
                                [getData]: true
                            }));
                        })
                    }
                    if (!_.isEmpty(isEdit)) {
                        isEdit.map(edit => {
                            const getData = "edit_" + edit.resource_key
                            setCheckedStates((prevState) => ({
                                ...prevState,
                                [getData]: true
                            }));
                        })
                    }
                    setgridData(result)
                }
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error(error);
        }

    }

    const handleUserPermission = (rowId, newValue, label, tabName, key) => {
        setCheck(prevState => {
            const updatedCheck = { ...prevState, [rowId]: newValue };
            if (newValue && key === 'edit') {
                updatedCheck["display_" + label] = true;
            }
            if (!newValue && key === 'display') {
                updatedCheck["edit_" + label] = false;
            }

            return updatedCheck;
        });

        const userPermissionObj = {
            is_editable: key === 'edit' ? newValue : false,
            is_active: key === 'display' ? newValue : key === 'edit' ? true : false,
            resource_key: label,
            resource_name: tabName,
            parent_resource_key: "",
        };

        setAssignPermission(prevAssignPermission => {
            const index = _.findIndex(prevAssignPermission, { resource_key: label });
            if (index === -1) return prevAssignPermission;

            const updatedRow = { ...prevAssignPermission[index] };

            if (key === "edit") {
                updatedRow.is_editable = newValue;
                if (newValue) updatedRow.is_active = true;
            } else if (key === "display") {
                updatedRow.is_active = newValue;

                if (!newValue) updatedRow.is_editable = false;
            }

            const updatedAssignPermission = [...prevAssignPermission];
            updatedAssignPermission[index] = updatedRow;
            return updatedAssignPermission;
        });

        setuserPermission(prevUserPermission => {
            const filtered = prevUserPermission.filter(
                perm => perm.resource_key !== label
            );
            return [...filtered, userPermissionObj];
        });
    };



    const handleOptionChange = (rowId, newValue, label, tabName, key, accId) => {
        setCheckedStates((prevState) => ({
            ...prevState,
            [rowId]: newValue,
        }));
        if (newValue) {
            obj = {
                is_editable: key === 'display' ? false : true,
                is_active: 'true',
                resource_key: label,
                resource_name: tabName,
                parent_resource_key: "",
            }
            if (key === 'edit') {
                const activeDisplayToggle = "display_" + label
                setCheckedStates((prevState) => ({
                    ...prevState,
                    [activeDisplayToggle]: newValue,
                }));
            }
        }
        else {
            obj = {
                is_editable: key === 'display' ? false : false,
                is_active: key === 'edit' ? true : false,
                resource_key: label,
                resource_name: tabName,
                parent_resource_key: "",
            }
            if (!newValue && key === 'display') {
                if (checkedStates.hasOwnProperty(rowId)) {
                    const data = "edit_" + label
                    setCheckedStates((prevState) => ({
                        ...prevState,
                        [data]: false,
                    }));
                }
            }
        }
        if (!(permission.hasOwnProperty('permissions'))) {
            setPermission((prev) => ({
                ...prev,
                ['permissions']: [obj]
            }))
        }
        else {
            const isExistData = _.findWhere(permission['permissions'], { resource_key: label })
            if (!_.isEmpty(isExistData)) {
                permission['permissions'].splice(_.indexOf(permission['permissions'], isExistData), 1)
            }
            permission['permissions'].push(obj)
        }
        if (permission.hasOwnProperty('permissions') && _.isEmpty(permission['permissions'])) {
            delete permission['permissions']
        }
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-end">
                <IconField className="d-flex gap-1 align-items-center rounded">
                    <InputIcon className="pi pi-search" />
                    <InputText className=' rounded' onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };
    const header = renderHeader();

    const assignGridBodyTemplate = (rowData) => {
        const getId = "edit_" + rowData.data.resource_key
        return (
            <div className='input-switch'>
                <InputSwitch
                    checked={checkedStates[getId] || false}
                    id={getId}
                    onChange={(e) => handleOptionChange(getId, e.value, rowData.data.resource_key, rowData.data.resource_name, 'edit', currentUserAccountId)}
                />
            </div>

        );
    };
    const assignGridTemplate = (rowData) => {
        const getId = "display_" + rowData.data.resource_key
        return (
            <div className='input-switch'>
                <InputSwitch
                    checked={checkedStates[getId] || false}
                    id={getId}
                    onChange={(e) => handleOptionChange(getId, e.value, rowData.data.resource_key, rowData.data.resource_name, 'display', currentUserAccountId)}
                />
            </div>

        )
    };
    const revokeGridBodyTemplate = (rowData) => {
        const getId = "edit_" + rowData.resource_key;
        return (
            <div className='input-switch'>
                <InputSwitch
                    checked={check[getId] ?? rowData.is_editable}
                    id={getId}
                    onChange={(e) =>
                        handleUserPermission(getId, e.value, rowData.resource_key, rowData.resource_name, 'edit')
                    }
                />
            </div>

        );
    };

    const revokeGridTemplate = (rowData) => {
        const getId = "display_" + rowData.resource_key;
        return (
            <div className='input-switch'>
                <InputSwitch
                    checked={check[getId] ?? rowData.is_active}
                    id={getId}
                    onChange={(e) =>
                        handleUserPermission(getId, e.value, rowData.resource_key, rowData.resource_name, 'display')
                    }
                />
            </div>

        );
    };

    const assignTemplate = (rowData) => {
        const isAssigned = _.findWhere(assignPermission, { resource_key: rowData.data.resource_key }) ? true : false;
        return (
            <FontAwesomeIcon icon="fa-solid fa-hand-point-right" onClick={(e) => { onAssignRowClicked(rowData.data) }}
                className={`f-18 color-green ${isAssigned ? 'controlcentre' : ''}`} />
        )

    }

    const RevokeTemplate = (rowData) => {
        return (
            <FontAwesomeIcon icon="fa-solid fa-hand-point-left" onClick={(e) => { onRevokeRowClick(rowData) }} className=' f-18 color-red' />
        )
    }
    
    const savePermisson = async () => {
        if (
            (!filterValues?.users) && 
            (!filterValues?.user_category)
        ) {
            showInfo('Info', "User or Category must be selected")
        }
        else {
            try {
                const payload = {
                    'permissions': userpermission,
                    "user_category_id": filterValues?.user_category?.user_category_id,
                    'modify_user_code': filterValues?.users?.user_code
                };
                const response = await services.getInvokeRemote('POST', Urls('UPSERTRESOURCEPERMISSIONS'), payload)
                if (response.body.data) {
                    showSuccess('Success', response.body.message)
                } else {
                    showError('Error', response.body.errorMessage)
                }
            } catch (error) {
                console.error(error);
            }
        }
    }


    useEffect(() => {
        if (!filterValues?.apiCall) return;

        const { type, users, user_category } = filterValues;

        if (type === "user" && users) {
            getUserPermission("user", 0, users.user_code);
        }
        else if (type === "category" && user_category) {
            getUserPermission("category", user_category.user_category_id, "0");
        }
        else {
            setAssignPermission([]);
            setCheck({});
            setFilterValues(prevValue => ({
                ...prevValue,
                users:null,
                user_category:null
            }));
        }
        setFilterValues(prev => ({ ...prev, apiCall: false }));

    }, [filterValues.apiCall]);


    const getUserPermission = async (key, event, usercode) => {
        if (key === 'user') {
            payload = {
                'requested_user_code': usercode,
                "user_category_id": 0
            }
        }
        else {
            payload = {
                'requested_user_code': usercode,
                "user_category_id": event
            };
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETRESOURCEPERMISSION'), payload)
            if (res?.body?.data?.resourcePermission) {
                const result = _.uniq(res.body.data.resourcePermission, "resource_key");
                const isActive = _.where(result, { is_active: true });
                const isEdit = _.where(result, { is_editable: true })
                if (!_.isEmpty(isActive)) {
                    isActive.map(active => {
                        const getData = "display_" + active.resource_key
                        setCheck((prevState) => ({
                            ...prevState,
                            [getData]: true
                        }));
                    })
                }
                if (!_.isEmpty(isEdit)) {
                    isEdit.map(edit => {
                        const getData = "edit_" + edit.resource_key
                        setCheck((prevState) => ({
                            ...prevState,
                            [getData]: true
                        }));
                    })
                }
                setAssignPermission(result)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const onAssignRowClicked = (event) => {
        if (
            (!filterValues?.users) && 
            (!filterValues?.user_category)
    ) {
            setPopupDataSelected({ users: [], categories: [] });
            setCategoryPopup(true);
            setPopupData(event);
            return;
        } else {
            
            if (event) {
                setCheck((prevState) => ({
                    ...prevState,
                    ['display_' + event.resource_key]: event.is_active ? true : false,
                    ['edit_' + event.resource_key]: event.is_editable ? true : false,
                }));
            }
            let userPermissionObj = {
                is_editable: event.is_editable ? true : false,
                is_active: event.is_active ? true : false,
                resource_key: event.resource_key,
                resource_name: event.resource_name,
                parent_resource_key: "",
            }
            const isExistData = _.findWhere(userpermission, { resource_key: event.resource_key })
            if (!_.isEmpty(isExistData)) {
                
                userpermission.splice(_.indexOf(userpermission, isExistData), 1)
            }
            setuserPermission((prevArray) => [...prevArray, userPermissionObj])
            if (filterValues?.users !== null || filterValues?.user_category !== null) {
                
                const isExist = _.findWhere(assignPermission, { resource_key: event.resource_key })
                if (_.isEmpty(isExist)) {
                    const tabIndex = _.findIndex(gridData, event)
                    gridData[tabIndex]['isCurrent'] = true
                    setAssignPermission((prevArray) => [...prevArray, event]);
                }
            }
        }
    }


    const onRevokeRowClick = (event) => {
        let updatedGridData = [...assignPermission]
        if (_.contains(updatedGridData, event)) {
            delete event.isCurrent
            const isExistData = _.indexOf(updatedGridData, event);
            updatedGridData.splice(isExistData, 1)
        }
        setAssignPermission(updatedGridData)
        let userPermissionObj = {
            is_editable: false,
            is_active: false,
            resource_key: event.resource_key,
            resource_name: event.resource_name,
            parent_resource_key: event.parent_resource_key,
        }
        const isExistData = _.findWhere(userpermission, { resource_key: event.resource_key })
        if (!_.isEmpty(isExistData)) {
            userpermission.splice(_.indexOf(userpermission, isExistData), 1)
        }
        setuserPermission((prevState) => [...prevState, userPermissionObj]);
    }

    const handlePopupUserSelected = (event, is_user) => {
        if (is_user) {
            setPopupDataSelected({ users: event.value, categories: [] });
        } else {
            setPopupDataSelected({ users: [], categories: event.value });
        }
    }

    const handleClose = (key) => {
        if (key === "users") {
            setPopupDataSelected((prev) => ({ ...prev, users: [] }));
        } else {
            setPopupDataSelected((prev) => ({ ...prev, categories: [] }));
        }
    }

    const handlePopupSave = async () => {
        try {
            if (_.isEmpty(popupDataSelected.users) && _.isEmpty(popupDataSelected.categories)) {
                showInfo('Info', "User or Category must be selected");
                return;
            } else {
                const isEdit = "edit_" + popupData.resource_key
                const isActive = "display_" + popupData.resource_key

                let resource_permission_category = [];
                if (!_.isEmpty(popupDataSelected.users)) {
                    popupDataSelected.users?.forEach((user) => {
                        const obj = {
                            user_code: user.user_code,
                            user_category_id: 0
                        }
                        resource_permission_category.push(obj);
                    })
                } else {
                    popupDataSelected.categories?.forEach((category) => {
                        const obj = {
                            user_code: 0,
                            user_category_id: category.user_category_id
                        }
                        resource_permission_category.push(obj);
                    })
                }

                const payload = {
                    "resource_permission_category": resource_permission_category,
                    "permissions": [
                        {
                            "is_editable": checkedStates[isEdit] === undefined ? popupData.is_editable : checkedStates[isEdit],
                            "is_active": checkedStates[isActive] === undefined ? popupData.is_active : checkedStates[isActive],
                            "resource_name": popupData.resource_name,
                            "resource_key": popupData.resource_key
                        }
                    ],
                }
                const response = await services.getInvokeRemote("POST", Urls("UPSERTMULTIRESOURCEPERMISSIONS"), payload)
                if (!response.body.error_status) {
                    showSuccess("success", response.body?.message);
                    setPopupDataSelected({ users: [], categories: [] });
                    setCategoryPopup(false);
                } else {
                    showError("error", response.body?.message);
                    return;
                }
            }
        } catch (error) {
            console.error("error saving permission", error);
        }
    }

    const buildTree = (resources) => {
        const resourceMap = {};

        resources.forEach((resource) => {
            const obj = {
                key: resource.resource_key,
                data: resource,
            };
            if (
                !_.isEmpty(
                    _.where(resources, { parent_resource_key: resource.resource_key })
                )
            ) {
                obj["children"] = [];
            }
            resourceMap[resource.resource_key] = obj;
        });

        const result = [];

        resources.forEach((resource) => {
            const currentResource = resourceMap[resource.resource_key];
            if (resource.parent_resource_key) {
                const parentResource = resourceMap[resource?.parent_resource_key];
                parentResource?.children?.push(currentResource);
            } else {
                result.push(currentResource);
            }
        });

        return result;
    };


    useEffect(() => {
        if (treeData && treeData.length > 0 && Object.keys(expandedKeys).length === 0) {
            const firstLevelKeys = {};
            treeData.forEach((node) => {
                firstLevelKeys[node.key] = true;
            });
            setExpandedKeys(firstLevelKeys);
        }
    }, [treeData]);


    useEffect(() => {
        setTreeData(buildTree(gridData))
    }, [gridData])

    return useMemo(() => ({
        filterValues, setFilterValues, tagRef, User, usercategory, savePermisson,
        loader, treeData, header, headerTemplate, assignGridTemplate, assignGridBodyTemplate, assignTemplate, assignPermission, revokeGridTemplate, revokeGridBodyTemplate, RevokeTemplate, categoryPopup, setCategoryPopup, popupData, popupDataSelected, handlePopupUserSelected, handlePopupSave, handleClose, globalFilter, expandedKeys, setExpandedKeys   
    }), [filterValues, setFilterValues, tagRef, User, usercategory, savePermisson,
        loader, treeData, header, headerTemplate, assignGridTemplate, assignGridBodyTemplate, assignTemplate, assignPermission, revokeGridTemplate, revokeGridBodyTemplate, RevokeTemplate, categoryPopup, setCategoryPopup, popupData, popupDataSelected, handlePopupUserSelected, handlePopupSave, handleClose, globalFilter, expandedKeys, setExpandedKeys])
}